package com.vizio.redwolf.utils

import io.ktor.client.plugins.HttpRequestTimeoutException
import kotlinx.coroutines.TimeoutCancellationException
import kotlinx.io.IOException
import kotlin.js.JsExport

expect suspend inline fun <R : Any> safeHttpCall(httpRequestInfo: HttpRequestInfo? = null, crossinline block: suspend () -> R): HttpResult<R>

const val DEFAULT_TIMEOUT: Long = 15000

suspend inline fun <R : Any> makeHttpCall(httpRequestInfo: HttpRequestInfo?, crossinline block: suspend () -> R): HttpResult<R> {
    return try {
        val result = block()
        HttpResult.Success(result)
    } catch (ex: HttpRequestTimeoutException) {
        ex.printStackTrace()
        HttpResult.Error(TimeoutException(ex.message.toStringorEmpty()), httpRequestInfo)
    } catch (ex: TimeoutCancellationException) {
        ex.printStackTrace()
        HttpResult.Error(ex, httpRequestInfo)
    } catch (ex: IOException) {
        ex.printStackTrace()
        HttpResult.Error(ex, httpRequestInfo)
    }
}

@JsExport
class TimeoutException(message: String) : Throwable(message)

@JsExport
class NetworkError(message: String, val exception: Throwable) : Throwable(message, exception)

@JsExport
data class HttpRequestInfo(
    val url: String,
    val method: String,
    val requestHeaders: String,
    val requestBody: String
)

@JsExport
sealed class HttpResult<out T : Any> {
    data class Success<out T : Any>(val data: T) : HttpResult<T>()
    data class Error(val exception: Throwable, val httpRequestInfo: HttpRequestInfo? = null) : HttpResult<Nothing>()
}